import styled from '@emotion/styled';
import { AnchorHTMLAttributes } from 'react';
import { BORDER_WIDTH } from '../../styles/borders';
import { COLOR, GREYSCALE } from '../../styles/colors';
import { OPACITY } from '../../styles/opacities';
import { SPACING } from '../../styles/spacing';
import withOpacity from '../../utils/withOpacity';
import { ButtonStyleProps } from './Button';
import { getButtonSizeStyle, getButtonVariantStyle } from './buttonStyles';

// an external link element (with href), styled as a button.
const ButtonExternalLink = styled.a<ButtonStyleProps & AnchorHTMLAttributes<HTMLAnchorElement>>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  max-width: 100%;
  overflow: hidden;
  width: ${({ fullWidth }) => (fullWidth ? '100%' : '')};
  margin: ${SPACING.none};
  border-style: solid;
  border-width: 2px;
  border-color: transparent;
  text-align: center;
  text-decoration: none;
  vertical-align: middle;
  white-space: ${({ noWrap }) => (noWrap ? 'nowrap' : 'normal')};
  text-overflow: ellipsis;
  user-select: none;
  cursor: pointer;
  @media print {
    display: ${({ hideForPrint }) => (hideForPrint ? 'none' : 'inline')};
  }
  :focus-within {
    outline: ${BORDER_WIDTH.sm} auto ${COLOR.blue};
  }

  /* Override inherited link hover styles - button link text should stay white when hovering */
  :hover,
  :focus {
    color: ${GREYSCALE.white};
  }

  /* Button sizes */
  ${({ size }) => getButtonSizeStyle(size)}

  /* Button variants */
  ${({ variant }) => getButtonVariantStyle(variant)}

  :active {
    box-shadow: inset ${SPACING.none} ${SPACING.xs} ${SPACING.sm}
      ${withOpacity(GREYSCALE.black, 0.125)};
  }

  :disabled {
    opacity: ${OPACITY.disabled};
    cursor: not-allowed;
  }
`;

export default ButtonExternalLink;
